export const sideBarWidth = "305px"
